import axios from 'axios';

let base = '';
const base_QY = 'http://mpc.sinosoftweixin.com';

// let baseUrl='http://localhost:9999/ewechat-qa-service-provider';
// let baseUrl='http://119.3.197.220:9999/ewechat-qa-service-provider';
let baseUrl='';
//http://119.3.197.220:9999/microservice-robot-server-provider


export const wxLogin = param =>{
    return axios({
        url:base_QY+'/api/robot/user/getuserinfo/'+param+'/health',
        method:"get"
    })

}

//     获取微信config配置信息   时间戳、签名、随机串等
export const getWechatConfig = param =>{
    // alert('getWechatConfig:'+param);
    return axios({
        url:base_QY+'/api/token/getappjssdkSign/health',
        method:"POST",
        data:param,
        headers:{
            "Content-Type":"application/text"
        }
    })

}


export const getWorkPlaces = () =>{
    return axios({
        url:base_QY+'/api/workplace/getWorkplaces',
        method:"get"
    })
}

export const punchInfo = param =>{
    return axios({
        url:base_QY+'/api/workplace/punch',
        data: param,
        method:"post"
    })
}